import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { ScheduleTriggerNodeData } from '../../../node-edit.type';
import { MatOption, MatSelect } from '@angular/material/select';
import { WorkflowModel } from '@models/workflow.model';

@Component({
  selector: 'edit-schedule-trigger',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    MatSelect,
    MatOption,
  ],
  templateUrl: './edit-schedule-trigger.component.html',
  styleUrl: './edit-schedule-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditScheduleTriggerComponent,
    },
  ],
})
export class EditScheduleTriggerComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<ScheduleTriggerNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public readonly intervalsEnum = WorkflowModel.ScheduleIntervals;
  public readonly intervalKeys = Object.keys(WorkflowModel.ScheduleIntervalsMap);
  public readonly intervalsMap = WorkflowModel.ScheduleIntervalsMap;
  public readonly hourKeys = Object.keys(WorkflowModel.AtHoursMap)
    .sort((a, b) => Number(a) - Number(b));
  public readonly hoursMap = WorkflowModel.AtHoursMap;
  public readonly dayKeys = Object.keys(WorkflowModel.DaysMap);
  public readonly daysMap = WorkflowModel.DaysMap;

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.SCHEDULE_TRIGGER.NAME'), [Validators.required]],
    interval: [WorkflowModel.ScheduleIntervals.Seconds, [Validators.required]],
    seconds: [1],
    minutes: [1],
    hours: [1],
    days: [1],
    weeks: [1],
    custom: [null],
    atMinute: [null],
    atHour: [WorkflowModel.AtHours.Midnight],
    atDay: [WorkflowModel.Days.Sunday],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        interval: this.selectedNodeForEdit().data.interval,
        seconds: this.selectedNodeForEdit().data.seconds ?? null,
        minutes: this.selectedNodeForEdit().data.minutes ?? null,
        hours: this.selectedNodeForEdit().data.hours ?? null,
        days: this.selectedNodeForEdit().data.days ?? null,
        weeks: this.selectedNodeForEdit().data.weeks ?? null,
        custom: this.selectedNodeForEdit().data.custom ?? null,
        atMinute: this.selectedNodeForEdit().data.atMinute ?? null,
        atHour: this.selectedNodeForEdit().data.atHour ?? null,
        atDay: this.selectedNodeForEdit().data.atDay ?? null,
      })
    }
  }
}
